import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  SupplyBillTableColumn,
  SupplyBillTableRow,
  SupplyCupGroupedContract,
} from "../../../core/models/supplies/supplies.model";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import "./SupplyContractsTable.scss";
import { formatTariffOptionLabel } from "../../../utils/formatters/formatters.util";
import { convertListToTableRows } from "../../../utils/components/supplies/supplies.util";

interface SupplyContractsTableProps {
  contractList: SupplyCupGroupedContract[];
}

export default function SupplyContractsTable({
  contractList,
}: SupplyContractsTableProps) {
  const supplyBillTableRows = useMemo(
    () => convertListToTableRows(contractList),
    [contractList]
  );

  const { t } = useTranslation();

  const supplyBillTableColumns: SupplyBillTableColumn[] | [] = [
    {
      id: "socialReason",
      label: "Razón social",
      align: "left",
      width: "30%",
    },
    {
      id: "cif",
      label: "CIF",
      align: "left",
      width: "10%",
    },
    {
      id: "tariff",
      label: "Tarifa",
      align: "left",
      width: "10%",
      cellContent: (row) => formatTariffOptionLabel(row.tariff),
    },

    {
      id: "period",
      label: "Periodo de contrato",
      align: "left",
      width: "20%",
    },
  ];

  return (
    <TableContainer className="supply-contracts-table">
      <Table>
        <TableHead>
          <TableRow>
            {supplyBillTableColumns.map(({ id, align, width, label }) => {
              return (
                <TableCell key={id} align={align} width={width}>
                  <Typography>{t(`Tablas.${label}`)}</Typography>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {supplyBillTableRows.map((row) => {
            return (
              <TableRow
                key={row.id}
                className={row.isContractActive ? undefined : "contract-inactive"}
              >
                {supplyBillTableColumns.map(
                  ({ id, align, width, cellContent }) => {
                    const cellValue = row[id as keyof SupplyBillTableRow];
                    return (
                      <TableCell align={align} width={width}>
                        {cellContent ? cellContent(row) : (cellValue as string)}
                      </TableCell>
                    );
                  }
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
